import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './Profile.css';

const Profile = () => {
  return (
    <div className="elegant-app">
      <Header />
      <main className="elegant-main">
        <div className="elegant-profile-container">
          <h1>个人资料页面</h1>
          <p>此页面正在开发中...</p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Profile; 